export const ACCOUNT_TYPE = {
  USER: "User",
  ADMIN: "Admin",
};

export const COURSE_TYPE = {
  BEGINNER: "Beginner",
  INTERMEDIATE: "Intermediate",
  ADVANCED: "Advanced",
  FREE: "Free",
  STRATERGY: "Stratergy",
};

export const COURSE_STATUS = {
  DRAFT: "Draft",
  PUBLISHED: "Published",
};
